import React from "react";
import "./addeditemmodal.css";
import DeleteCartItemBtn from "../DeleteCartItemBtn/DeleteCartItemBtn";
import { setToastMessage } from '../../appState/slices/util/utilSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toastMessages } from '../../constants/toastMessage';
import { useNavigate } from "react-router-dom";

const AddedItemModal = ({ product, color, purity, quality, price, ringsize, diamondtype }) => {
    const dispatch = useDispatch();
  const navigate = useNavigate()

    const gotocart = async() => {
        
        await navigate(`/cart`);
        dispatch(
            setToastMessage({
                type: toastMessages.TYPE.ERROR,
                message: "",
                show: false,
            })
        )
    }
    return (
        <div className="cart-modal">
            <div className="cart-modal-top">
                <div className="t5">Added to cart</div>
                <div
                    className={`cart-modal-close-icon`}
                    onClick={() => {
                        dispatch(
                            setToastMessage({
                                type: toastMessages.TYPE.ERROR,
                                message: "",
                                show: false,
                            })
                        );
                    }}
                >
                    x
                </div>
            </div>
            <div className='modal-cart-container'>
                <div className="cartcardimageandheart">
                    <img className='modal-cart-image' src={product.defaultImageUrl} />
                    {/* <DeleteCartItemBtn styleclass={"deletebutton-cart-modal"} cartid={product._id} productid={product._id} quantity={1} /> */}
                </div>
                <div className='modal-cart-details'>
                    <div className="">
                        <div className='t6'>
                            {product.name}
                        </div>
                        <div className='t6'>
                            ₹ {price}
                        </div>
                        {/* <h6 className="t8 cart-modal-category"><small className="cardcategorytext text-muted">MEN | TSHIRT</small></h6> */}
                         <div className="addeditemmodal-smalltext">
            {purity} | {diamondtype === "lab grown" ? "LGD" : "NATURAL"} | {quality} {ringsize ? ` | ${ringsize}` : ""}
          </div>
          <br />
                    </div>
                    <div className={`colouredcircle lightbordercircle`} style={{ backgroundColor: color }}></div>
                </div>
            </div>
            <div className="gotocartbtn" onClick={gotocart}>
                Go to cart
            </div>
        </div>

    )
}

export default AddedItemModal;